'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

require('./text-input.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var STYLE_BASE = 'zk-text-input-';

var TextInput = function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput(props) {
    _classCallCheck(this, TextInput);

    var _this = _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props));

    _this.inputRef = null;
    _this.textAreaRef = null;

    _this.focus = function () {
      _this.inputRef && _this.inputRef.focus();
      _this.textAreaRef && _this.textAreaRef.focus();
    };

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          shouldBlurOnSubmit = _this$props.shouldBlurOnSubmit,
          onSubmitEditing = _this$props.onSubmitEditing,
          clearSearch = _this$props.clearSearch;
      e.stopPropagation();

      if (e.key === 'Escape' && clearSearch) {
        clearSearch();
      } else if (e.key === 'Enter') {
        if (e.key === 'Enter' && !e.shiftKey) {
          if (onSubmitEditing) {
            // prevent "Enter" from inserting a newline
            onSubmitEditing(e.target.value);
          }

          if (shouldBlurOnSubmit) {
            _this.onBlur(e);
          }
        }
      }
    };

    _this.onBlur = function (e) {
      if (_this.props.onBlur) {
        _this.props.onBlur(e);
      }

      _this.setState({
        autoSelect: false
      });
    };

    _this.onFocus = function (e) {
      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }
    };

    _this.onChangeText = function (e) {
      if (_this.props.onChangeText) {
        _this.props.onChangeText(e);
      }

      if (_this.props.autoSelect) {
        _this.setState({
          autoSelect: false
        });
      }
    };

    _this.state = {
      autoSelect: props.autoSelect
    };
    return _this;
  }

  _createClass(TextInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoSelect) {
        this.inputRef && this.inputRef.setSelectionRange(0, -1);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames,
          _this2 = this;

      var _props = this.props,
          className = _props.className,
          disabled = _props.disabled,
          error = _props.error,
          multiline = _props.multiline,
          name = _props.name,
          onChangeText = _props.onChangeText,
          testid = _props.testid,
          type = _props.type,
          value = _props.value,
          rest = _objectWithoutProperties(_props, ['className', 'disabled', 'error', 'multiline', 'name', 'onChangeText', 'testid', 'type', 'value']);

      var restProps = (0, _omit2.default)(rest, ['fetching', 'autoSelect', 'clearSearch', 'containerClassName', 'editable', 'inputComponent', 'onChangeText', 'onSelectionChange', 'onSubmitEditing', 'onValueChange', 'shouldBlurOnSubmit', 'submitFunc', 'xIconTestId']);

      var props = _extends({
        disabled: disabled,
        onKeyDown: this.handleKeyDown,
        type: type,
        name: name,
        className: (0, _classnames2.default)((_classNames = {
          'zk-text-input': true
        }, _defineProperty(_classNames, STYLE_BASE + 'error', error), _defineProperty(_classNames, className, !!className), _classNames)),
        'data-testid': testid,
        autoComplete: 'on',
        onChange: onChangeText,
        value: value
      }, restProps, this.props.input);

      return multiline ? _react2.default.createElement('textarea', _extends({
        ref: function ref(node) {
          return _this2.textAreaRef = node;
        },
        rows: '4',
        cols: '50',
        style: {
          resize: 'none'
        }
      }, props)) : _react2.default.createElement('input', _extends({
        ref: function ref(node) {
          return _this2.inputRef = node;
        }
      }, props));
    }
  }]);

  return TextInput;
}(_react.Component);

TextInput.propTypes = {
  autoSelect: _propTypes2.default.bool,
  multiline: _propTypes2.default.bool
};
TextInput.defaultProps = {
  autoSelect: false,
  type: 'text'
};
exports.default = TextInput;